import { render, staticRenderFns } from "./coming-due.vue?vue&type=template&id=d5047e0a&scoped=true&"
import script from "./coming-due.vue?vue&type=script&lang=js&"
export * from "./coming-due.vue?vue&type=script&lang=js&"
import style0 from "./coming-due.vue?vue&type=style&index=0&id=d5047e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5047e0a",
  null
  
)

export default component.exports